import Image from 'next/image';
import { cn } from '@/app/utils/cn';
import { getDotcmsImageURL } from '@/app/utils/getDotcmsImageURL';

function ImageComponent(props) {
    const {
        identifier,
        fileAsset,
        title,
        asset,
        imagePrimaryLoad,
        width,
        height,
        alt,
        quality,
        positionCenter,
        paragraphSpacing = 'nospace',
        // Optional hook so CSS can still identify an `Images` contentlet. The SDK used to
        // expose `data-dot-type` for this, but it strips that metadata outside edit mode.
        dataComponent
    } = props;
    const src =
        fileAsset?.idPath ||
        fileAsset ||
        asset?.idPath ||
        asset ||
        getDotcmsImageURL({ src: identifier });
    return src ? (
        <>
            <Image
                data-component={dataComponent}
                priority={!!imagePrimaryLoad}
                src={src}
                alt={alt || title}
                sizes={
                    width
                        ? `${width}px`
                        : '(max-width: 768px) calc(100vw - 32px), (max-width: 1200px) 50vw, 1200px'
                }
                width={width || 0}
                quality={quality || 100}
                height={height || 0}
                style={{
                    ...(height ? { height: `${height}px` } : {}),
                    ...(width ? { width: `${width}px` } : {})
                }}
                className={cn(
                    !height && 'h-auto',
                    !width && 'w-full',
                    positionCenter && 'mx-auto',
                    paragraphSpacing !== 'nospace' && `spacing-${paragraphSpacing}`
                )}
            />
        </>
    ) : null;
}

export default ImageComponent;
